import React from 'react'
import '../App.css'
import Header from "../Components/Header.js"
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import { Home } from 'react-feather'
import { useNavigate, Link } from 'react-router-dom'

export default function Legenda() {

  let navigate = useNavigate()  
  
  return (
    <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
      <Header />
      <div className='Legenda'>
        
        <span className="titolo-sezione">Difficoltà Escursionistiche</span>

        <span className="riga-testo">
          Si utilizzano le sigle CAI per distinguere l'impegno richiesto dagli itinerari e per definire il limite tra difficoltà escursionistiche ed alpinistiche.
        </span>

        <span className="riga-testo difficolta">
          T = Turistico: Itinerario su stradine, mulattiere o larghi sentieri. I percorsi generalmente non sono lunghi, non presentano alcun problema di orientamento e non richiedono un allenamento specifico se non quello tipico della passeggiata.
        </span>

        <span className="riga-testo difficolta">
          E = Escursionisti: Itinerari su sentieri od evidenti tracce in terreno di vario genere (pascoli, detriti, pietraie...). Sono generalmente segnalati con vernice od ometti.
        </span>

        <span className="riga-testo difficolta">
          EE = Escursionisti Esperti: Sono itinerari generalmente segnalati ma con qualche difficoltà: il terreno può essere costituito da pendii scivolosi.
        </span>

        <span className="riga-testo difficolta">
          EEA = Escursionisti Esperti con Attrezzatura: Vengono indicati i percorsi attrezzati (o vie ferrate), richiedono l'uso dei dispositivi di autoassicurazione.
        </span>

        <span className="titolo-sezione">Difficoltà Alpinistiche</span>

        <span className="riga-testo">
          Le valutazioni si riferiscono a condizioni montane e meteo ottimali. Le capacità e la preparazione tanto fisica quanto psicologica deve essere adeguata.
        </span>

        <span className="riga-testo difficolta">
          I = Primo Grado (F): E' la forma più semplice dell'arrampicata: si devono usare frequentemente le mani per mantenere l'equilibrio.
        </span>

        <span className="riga-testo difficolta">
          II = Secondo Grado (PD): Inizia l'arrampicata vera e propria: è necessario spostare un arto per volta con una corretta impostazione dei movimenti.
        </span>

        <span className="riga-testo difficolta">
          III = Terzo Grado (AD): La struttura rocciosa è più verticale, appigli e appoggi sono più radi.
        </span>

        <span className="riga-testo difficolta">
          IV = Quarto Grado (D): Appoggi ed appigli cominciano ad essere esigui: è richiesta una certa tecnica nel superare passaggi.
        </span>

      </div>
      {/* Sezione Disclaimer */}
      <div className="d-flex justify-content-center w-100">
        <Link 
          to="/disclaimer" 
          className="mb-4 text-danger fw-bold text-uppercase"
          style={{ textDecoration: 'underline', letterSpacing: '1px' }}
        >
          Leggi il Disclaimer e le Note Legali
        </Link>
      </div>
      <div className="d-flex flex-column align-items-center pb-5 pt-3">

        {/* Icona Home */}
        <Home 
          size={48} 
          style={{ cursor: 'pointer', color: '#1b5e20' }} 
          onClick={() => navigate('/')}
        />
      </div>
    </div>
  )
}
